import {
  Application,
  DisclosuresAttribute,
  FraudAlloyInitResponse,
  Order,
  OutgoingApplication,
} from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { logger } from '../logger';
import { HandlerResponse, toErrorResponse, toResultResponse } from './base';

export const APPLICATION_URI = '/api/application';

interface CreateApplicationOptions {
  order: Order;
  extensions: Application['extensions'];
  disclosures: DisclosuresAttribute;
  retargetingURL: string;
  referrerURL: string;
  neuroIdTokens: Pick<FraudAlloyInitResponse, 'neuroUserId' | 'neuroIdSiteId'>;
  decibelSessionId?: string;
  parentApplicationId?: string;
}

export async function createApplication(
  options: CreateApplicationOptions,
  apiFetch: APIFetch
): Promise<HandlerResponse<Application>> {
  const {
    order,
    disclosures,
    extensions,
    retargetingURL,
    referrerURL,
    neuroIdTokens,
    decibelSessionId,
    parentApplicationId,
  } = options;
  const body: OutgoingApplication = {
    order,
    disclosures,
    extensions,
    retargetingURL,
    clientInfo: [],
  };

  if (neuroIdTokens) {
    body.clientInfo = [
      {
        type: 'neuroUserID',
        value: neuroIdTokens?.neuroUserId,
      },
      {
        type: 'siteID',
        value: neuroIdTokens?.neuroIdSiteId,
      },
    ];
  }

  if (decibelSessionId) {
    body.clientInfo?.push({
      type: 'decibel_session_id',
      value: decibelSessionId,
    });
  }

  if (referrerURL) {
    body.clientInfo?.push({
      type: 'referrerURL',
      value: referrerURL,
    });
  }

  if (parentApplicationId) {
    body.parentApplicationID = parentApplicationId;
  }

  const res: APIResponse<Application> = await apiFetch<
    Application,
    OutgoingApplication
  >(
    APPLICATION_URI,
    {
      body,
    },
    Application
  );

  if (res.error) {
    logger.error({ err: res.error }, 'Error creating application');
    return toErrorResponse(res.error);
  }

  return toResultResponse(res.response.body);
}
